import { GET } from "../../../API/get";

const fetchApiData = async (url) => {
    const response = await GET(url);
    return response?.status === "Success" ? response : null;
}

export const fetchPersonalDeletedDocuments = (document_id) => fetchApiData(`ftm/personal/deleted/documents/list/${document_id}`);
export const fetchDeletedCertificatesList = (document_id) => fetchApiData(`ftm/deleted/certificates/list/${document_id}`);